"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const formik_1 = require("formik");
const common_1 = require("../../../common");
const services_1 = require("../../services");
const use_feature_1 = require("../../hooks/use-feature");
const OperatorCheckbox_1 = tslib_1.__importDefault(require("../clusterConfiguration/operators/OperatorCheckbox"));
const operatorSpecs_1 = require("../../../common/components/operators/operatorSpecs");
const OperatorsSelect = ({ cluster, bundles, preflightRequirements, }) => {
    const [isLoading, setIsLoading] = (0, common_1.useStateSafely)(true);
    const { addAlert } = (0, common_1.useAlerts)();
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [supportedOperators, setSupportedOperators] = (0, common_1.useStateSafely)([]);
    const isSingleClusterFeatureEnabled = (0, use_feature_1.useFeature)('ASSISTED_INSTALLER_SINGLE_CLUSTER_FEATURE');
    const { values } = (0, formik_1.useFormikContext)();
    React.useEffect(() => {
        const fetchSupportedOperators = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                const fetchedOperators = yield services_1.OperatorsService.getSupportedOperators();
                setSupportedOperators(fetchedOperators);
            }
            catch (error) {
                (0, common_1.handleApiError)(error, () => addAlert({ title: 'Failed to fetch operators', message: (0, common_1.getApiErrorMessage)(error) }));
            }
            finally {
                setIsLoading(false);
            }
        });
        void fetchSupportedOperators();
    }, [addAlert, setSupportedOperators, setIsLoading]);
    const { byCategory, byKey: opSpecs } = (0, operatorSpecs_1.useOperatorSpecs)();
    const operators = React.useMemo(() => {
        return supportedOperators.filter((op) => {
            if (!isSingleClusterFeatureEnabled) {
                return true;
            }
            return common_1.singleClusterOperators.includes(op);
        });
    }, [isSingleClusterFeatureEnabled, supportedOperators]);
    if (isLoading) {
        return React.createElement(common_1.LoadingState, null);
    }
    const selectedOperators = values.selectedOperators.filter((opKey) => operators.includes(opKey) && !!opSpecs[opKey]);
    return (React.createElement(react_core_1.ExpandableSection, { toggleText: `Single Operators (${operators.length} | ${selectedOperators.length} selected)`, onToggle: () => setIsExpanded(!isExpanded), isExpanded: isExpanded, "data-testid": "single-operators-section" },
        React.createElement(react_core_1.Stack, { hasGutter: true, "data-testid": 'operators-form' }, Object.entries(byCategory).map(([categoryName, specs]) => {
            const categoryOperators = specs.filter((spec) => operators.includes(spec.operatorKey));
            if (categoryOperators.length === 0) {
                return null;
            }
            return (React.createElement(React.Fragment, { key: categoryName },
                React.createElement(react_core_1.StackItem, null,
                    React.createElement("strong", null, categoryName)),
                categoryOperators.map((spec) => (React.createElement(react_core_1.StackItem, { key: spec.operatorKey },
                    React.createElement(OperatorCheckbox_1.default, Object.assign({ bundles: bundles, operatorId: spec.operatorKey, cluster: cluster, openshiftVersion: cluster.openshiftVersion, preflightRequirements: preflightRequirements }, spec)))))));
        }))));
};
exports.default = OperatorsSelect;
//# sourceMappingURL=OperatorsSelect.js.map